/* eslint-disable vue/return-in-computed-property */
/* eslint-disable vue/return-in-computed-property */
<template>
    <div class="themes-list themes relative">
        <img v-if="items && items.length" :class="{sm: $vuetify.breakpoint.sm}" class="absolute decor-one" width="87px" height="87px" src="@/assets/images/front/Ellipse 131.png">
        <img v-if="items && items.length" :class="{sm: $vuetify.breakpoint.sm}" class="absolute decor-two" width="170px" height="45px" src="@/assets/images/front/Vector 58.png">
        <div v-if="items && items.length" class="roboto-bold-24 ml-6 ml-sm-12 clr-black-38">Разделы</div>
        <div v-if="items && items.length">
            <v-row class="theme-wraper mt-7 ml-sm-4">
                <v-col class="relative" cols="12" sm="6" md="4" lg="3" xl="2" v-for="(theme, i) in items" :key="i">
                    <div class="theme mb-4 mb-md-6 pointer" :class="{sm: $vuetify.breakpoint.sm, xs: $vuetify.breakpoint.xs}"  @click="toTheme(theme)">
                        <div class="w-100 text-center text-wrap px-7 roboto-normal-24 clr-black-38">{{theme.name}}</div>
                    </div>
                    <img 
                        class="add-theme pointer z-index-100" 
                        :class="{locationButton: locationButtonAdd, xs: $vuetify.breakpoint.xs}" 
                        @click="addNewTheme = true" v-if="!addNewTheme && i == indexForLocationButtonAdd" 
                        src="./../../assets/images/components/button-add-green.png">
                    <div v-if="addNewTheme && i == indexForLocationButtonAdd">
                        <input 
                            class="roboto-normal-24 clr-black-38 theme-add pointer"
                            :class="{sm: $vuetify.breakpoint.sm, xs: $vuetify.breakpoint.xs, locationInput: locationButtonAdd}"
                            required
                            autofocus 
                            placeholder="Введите название раздела"
                            @input="inputTheme = true"
                            v-model="nameTheme"
                        >
                        <div v-if="inputTheme && nameTheme" class="absolute button-ok roboto-normal-24 clr-black-38 pointer" :class="{xs: $vuetify.breakpoint.xs, sm: $vuetify.breakpoint.sm, locationOk: locationButtonAdd, locationOk_sm: locationButtonAdd && $vuetify.breakpoint.sm}" @click="toAddTheme()">OK</div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <div class="information" v-else>
            <div class="roboto-bold-24 clr-black-38">У Вас нет ни одного раздела.</div>
            <div class="roboto-bold-24 clr-black-38 mt-8"><router-link to="/theme">Нажмите сюда</router-link>, чтобы создать новый раздел!</div>
        </div>
        <div class="decor-three d-none d-md-block" v-if="items && items.length">
            <img class="right" width="141px" height="124px" src="@/assets/images/front/Group 873.png">
        </div> 
        <div class="decor-four" v-else>
            <img class="right" width="141px" height="124px" src="@/assets/images/front/Group 873.png">
        </div>             
    </div>
</template>

<script lang='ts'>
        import {mapGetters, mapMutations, mapActions} from 'vuex'
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'

    export default Vue.extend({
        props: {
            items: Array,
        },
        components: {
            ...mapGetters(['themes']),
        },
        data() {
            return {
                addNewTheme: false,
                inputTheme: false,
                nameTheme: '',
            }
        },
        computed: {
            ...mapGetters(['themes']),
            locationButtonAdd () {
                const itemsLength = this.items.length
                return (!(itemsLength%6) && this.$vuetify.breakpoint.xl) || (!(itemsLength%4) && this.$vuetify.breakpoint.lg) || (!(itemsLength%3) && this.$vuetify.breakpoint.md) || (!(itemsLength%2) && this.$vuetify.breakpoint.sm)
            },
            indexForLocationButtonAdd() {
                const itemsLength = this.items.length
                if (!(itemsLength%6) && this.$vuetify.breakpoint.xl) {
                    return itemsLength - 6
                } else if (!(itemsLength%4) && this.$vuetify.breakpoint.lg) {
                    return itemsLength - 4
                } else if (!(itemsLength%3) && this.$vuetify.breakpoint.md) {
                    return itemsLength - 3
                } else if (!(itemsLength%2) && this.$vuetify.breakpoint.sm) {
                    return itemsLength - 2
                } else {
                    return itemsLength - 1
                }
            }
        },
        methods: {
            ...mapActions(['setRelavantNotices', 'addTheme', 'saveOrderThemes']),
            ...mapMutations(['SET_CURRENT']),
            toTheme(theme){
                this.SET_CURRENT(theme)
                this.setRelavantNotices(theme.tasks.filter(el => !el.completed)[0])                
                this.$router.push('/theme/' + theme.route_name)
            },
            toAddTheme(){
                this.addTheme({name: this.nameTheme}).then(() => {
                    this.addNewTheme = false
                    this.inputTheme = false
                    this.nameTheme = ''
                    const themes_id = this.themes.map(item => item._id)
                    this.saveOrderThemes(themes_id)
                })
            },
        },
    })

    </script>

<style lang="scss" scoped>
    .themes {
        padding: 72px 1% 0 1%;
        background-image: url('./../../assets/images/front/Rectangle 965.png');
        background-size: cover;
        background-position-y: bottom;
        width: 100%;
        .information {
            margin-top:117px;
            margin-left: 11%;
        }
        .decor-one {
            left:535px;
            top:30px;
            &.sm {
                left:485px; 
            }
        }
        .decor-two {
            left:450px;
            &.sm {
                left:400px; 
            }
        }
        .decor-three {
            margin-top:-60px;
            margin-right:100px;
        }
        .decor-four {
            margin-top: 120px;
            margin-right:6%;
        }
        .theme-wraper {
            display:flex;
            flex-flow:wrap;
            .add-theme {
                right: -50px;
                bottom: 50px;
                height: 33.91px;
                position: absolute; 
                &.locationButton {
                    left: 5px;
                    bottom: -50px;
                }
                &.xs {
                    position: static;
                    height: 50px;
                    margin-left: 44%;
                }
            }
        }
        .theme {
            max-width: 289px;
            height: 67px;
            background: #BDFFDF;
            border-radius: 25px;
            display: flex;
            align-items: center;
            &.sm {
                max-width: 260px;
            }
            &.xs {
                max-width: unset;
            }
        }
        .theme:hover {
            background: #30F895;
        }
        .theme-add {
            width: 289px;
            height: 67px;
            background: #BDFFDF;
            border-radius: 25px;
            display: flex;
            align-items: center;
            outline: none;
            padding: 0 25px;
            position: absolute;
            right: -300px;
            bottom: 36px;
            &.sm {
                width: 260px;
                right: -275px;
                bottom: 28px;
            }
            &.xs {
                width: 95%;
                bottom: -80px;
                left:12px;
                padding: 0 75px 0 20px;
            }
            &.locationInput {
                left: 5px;
                bottom: -75px;
            }
    }
        .button-ok {
            right: -333px;
            bottom: 53px;
            &.sm {
                right: -310px;
                bottom: 44px;
            }
            &.xs {
                right: 25px;
                bottom: -65px;
            }
            &.locationOk {
                left: 295px;
                bottom: -55px;
            }
            &.locationOk_sm {
                left: 267px;
                bottom: -60px;
            }
        }
        input::placeholder {
            color:#383838;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 21px;
        }
    }
</style>
